import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PessoaEditModel } from '../../../models/pessoa-Edit.Model';
import { PessoaModel } from '../../../models/pessoa.model';

@Injectable({
  providedIn: 'root',
})
export class CadastroService {
  httpClient = inject(HttpClient);

  httpOptions = {
    withCredentials: true,
  };

  async adicionarUsuario(usuario: PessoaModel) {
    return lastValueFrom(
      this.httpClient.post<any>(
        `${environment.apiPessoa}/create`,
        JSON.stringify(usuario),
        this.httpOptions
      )
    );
  }

  async atualizarUsuario(usuario: PessoaEditModel) {
    return lastValueFrom(
      this.httpClient.put<any>(
        `${environment.apiPessoa}/update`,
        JSON.stringify(usuario),
        this.httpOptions
      )
    );
  }

  buscarCep(cep: string) {
    const url = `https://viacep.com.br/ws/${cep}/json`;
    return lastValueFrom(this.httpClient.get(url));
  }

  async buscarUsuario(): Promise<PessoaModel> {
    return lastValueFrom(
      this.httpClient.get<PessoaModel>(
        `${environment.apiPessoa}/findById`,
        this.httpOptions
      )
    );
  }
}
